import axiosSso from "@/api/interceptor_sso";

// 环境配置
export function getUserSetting(params?: any) {
  return axiosSso.get("/agent/profiles/user-info", { params });
}

// 修改密码
export function putUpdatePwd(data: any) {
  return axiosSso.put("/agent/profiles/update-password", data);
}
